import { ConfirmationType } from './types';

export const getConfirmationData = (type: ConfirmationType) => {
  switch (type) {
    case ConfirmationType.UNSAVED_CHANGES:
      return {
        titleKey: 'data.ignore_changes',
        messageKey: 'data.ignore_changes_prompt',
      };
    case ConfirmationType.UNSAVED_CHANGES_WITH_PHOTOS:
      return {
        titleKey: 'data.ignore_changes_with_photos',
        messageKey: 'data.ignore_changes_with_photos_prompt',
      };
    case ConfirmationType.PENDING_UPLOADS:
      return {
        titleKey: 'photos.upload_pending_title',
        messageKey: 'photos.upload_pending_content',
      };
    case ConfirmationType.UNSAVED_CHANGES_TAB_SWITCH:
      return {
        titleKey: 'data.save_changes',
        messageKey: 'data.save_changes_prompt',
      };
    default:
      return {
        titleKey: 'data.ignore_changes',
        messageKey: 'data.ignore_changes_prompt',
      };
  }
};
